import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../core/services/login.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../core/services/storage.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { LanguageModalComponent } from '../components/language-modal/language-modal.component';
import { CommonService } from '../core/services/common.service';
import { HttpClient } from '@angular/common/http';
import { AssessmentModalComponent, AssessmentAccount } from '../components/assessment-modal/assessment-modal.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public userloginForm!: FormGroup;
  public loginErrResp: string = '';
  public loginErrMsg: string = '';
  isSubmitted: boolean = false;
  modalRef!: BsModalRef;
  uaePassUrl: string = '';
  isLoginFailed: boolean = false;
  isConfirmed: boolean = false;
  accounts: any = []
  errorMessage: string | null = null;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    private storageService: StorageService,
    private modalService: BsModalService,
    private commonService: CommonService,
    private http: HttpClient
  ) { }
  showErrorPopup(): void {
    alert(this.errorMessage); // Trigger your popup modal here
  }
  ngOnInitOld(): void {
    sessionStorage.clear();
    this.loginService.loadConfig().subscribe({
      next: (data) => {
        const key = data?.data?.key;
 //console.log("loaded")
        if (key) localStorage.setItem('sec_key', key);
      },
      error: (err) => {
        console.error('Failed to fetch config:', err);
        this.loginErrMsg = "Something went wrong during the login, please try again later!";
      }
    });
    //  const rawUrl = window.location.href;

    // const urlObj = new URL(rawUrl);

    // const errorType = urlObj.searchParams.get('error');
    const hash = window.location.hash;  // "#/login?error=sso_failed"

    // Remove the '#' character
    const hashWithoutHash = hash.substring(1);  // "/login?error=sso_failed"

    // Split at '?'
    const [path, queryString] = hashWithoutHash.split('?');

    let errorType = null;

    if (queryString) {
      // Use URLSearchParams on the queryString part only
      const params = new URLSearchParams(queryString);
      errorType = params.get('error');
    }
    // console.log("error type ", errorType)
    if (errorType === 'sso_failed' || errorType === 'userid_not_found' || errorType === 'login_failed') {
      this.loginService.showSsoErrorPopup("The portal access is restricted for the business user. However please reach out to below team for further review.")
    }
    this.userloginForm = this.formBuilder.group({
      userId: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    // 🔍 Check for SSO login query param
    this.activatedRoute.queryParams.subscribe(params => {
      // console.log("params ", params)
      if (params['sso'] === 'true') {
        this.handleSsoLogin();
      }
      if (params['error']) {
 //console.log("error uaepass", params['error'])
        if (params['error'] == 'cancelledOnApp') {
          this.loginErrMsg = "User cancelled the login.";
          this.isLoginFailed = true
        }
      } else {
        this.loginErrMsg = "Something went wrong during the login, please try again later!";
      }
      // console.log(this.loginErrMsg)

      if (params['code'] && params['state']) {
        this.handleUaepassCallback(params['code'], params['state']);
      }

    });

    const uaepassEndPoint = 'https://stg-id.uaepass.ae/'
    const redirectUri = encodeURIComponent(window.location.origin); // or environment variable
    // console.log(redirectUri)
    const clientId = 'diez_compliance_web_stage';
    const responseType = 'code';
    const state = 'pd3PgezRwk596u2yfRwqOgru';
    const scope = encodeURIComponent(
      'urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId'
    );
    const acrValues = encodeURIComponent('urn:safelayer:tws:policies:authentication:level:low');

    this.uaePassUrl = `${uaepassEndPoint}idshub/authorize?redirect_uri=${redirectUri}&client_id=${clientId}&response_type=${responseType}&state=${state}&scope=${scope}&acr_values=${acrValues}`;
  }
ngOnInit(): void {
  const preBootQuery = sessionStorage.getItem('pre_boot_query_params');
  const savedState = sessionStorage.getItem('uaepass_state');

  sessionStorage.removeItem('pre_boot_query_params');
  sessionStorage.removeItem('uaepass_state');
  sessionStorage.clear(); 

  this.loginService.loadConfig().subscribe({
    next: (data) => {
      const key = data?.data?.key;
      if (key) localStorage.setItem('sec_key', key);
    },
    error: (err) => {
      console.error('Failed to fetch config:', err);
      this.loginErrMsg = "Something went wrong during the login, please try again later!";
    }
  });

  this.userloginForm = this.formBuilder.group({
    userId: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });

  if (preBootQuery) {
    const params = new URLSearchParams(preBootQuery);
    const uaeError = params.get('error');
    const uaeErrorDescription = params.get('error_description');
    const uaeCode = params.get('code');
    const uaeState = params.get('state');

    if (uaeError) {
      console.log('UAE Pass error:', uaeError, uaeErrorDescription);
      this.loginErrMsg = "User cancelled the login." //uaeErrorDescription || 'UAE Pass login failed or was cancelled.';
      this.isLoginFailed = true;
    } else if (uaeCode && uaeState) {
      if (uaeState !== savedState) {
        console.error('State mismatch — possible CSRF or stale session');
        this.loginErrMsg = 'Security validation failed. Please try logging in again.';
        this.isLoginFailed = true;
      } else {
        this.handleUaepassCallback(uaeCode, uaeState);
      }
    }
  }

  this.activatedRoute.queryParams.subscribe(params => {
    if (params['sso'] === 'true') {
      this.handleSsoLogin();
    }

    if (params['error']) {
      const errorType = params['error'];
      if (['sso_failed', 'userid_not_found', 'login_failed'].includes(errorType)) {
        this.loginService.showSsoErrorPopup(
          "The portal access is restricted for the business user. However please reach out to below team for further review."
        );
      } else {
        this.loginErrMsg = 'Something went wrong during the login, please try again later!';
        this.isLoginFailed = true;
      }
    }
  });
}

  redirectToUaePass() {
  const state = crypto.randomUUID();
  sessionStorage.setItem('uaepass_state', state);

  const uaepassEndPoint = 'https://stg-id.uaepass.ae/';
  const redirectUri = encodeURIComponent(window.location.origin);
  const clientId = 'diez_compliance_web_stage';
  const responseType = 'code';
  const scope = encodeURIComponent(
    'urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId'
  );
  const acrValues = encodeURIComponent('urn:safelayer:tws:policies:authentication:level:low');

  const uaePassUrl = `${uaepassEndPoint}idshub/authorize?redirect_uri=${redirectUri}&client_id=${clientId}&response_type=${responseType}&state=${state}&scope=${scope}&acr_values=${acrValues}`;

  window.location.href = uaePassUrl;
}

  clearErrMsg(event: any) {
    this.loginErrResp = '';
  }

  closePopup() {
    this.loginErrMsg = '';
    this.isLoginFailed = false;
  }

  getControl(controlName: string): AbstractControl {
    return this.userloginForm.controls[controlName];
  }

  goToQuestionnaire() {
    this.isSubmitted = true;
    if (this.userloginForm.valid) {
      const loginData = {
        userId: this.userloginForm.value.userId,
        password: this.userloginForm.value.password
      };
      this.loginService.verifyUser(loginData).subscribe((data: any) => {
        if (data?.token) {
          localStorage.setItem('auth_token', data.token);
        }
        // console.log("res")
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        if (decryptedData?.isAuth === true) {
          this.isSubmitted = false;
          this.loginService.setSession(decryptedData);
          this.loginService.openLanguageModal();
        } else if (data?.error) {
          this.loginErrResp = data?.error.errMsg;
        }
      });
    }
  }

  handleSsoLogin() {
    this.activatedRoute.queryParams.subscribe(params => {
      const nonce = params['nonce'];
      if (!nonce) {
        this.loginErrResp = 'Missing nonce for SSO validation.';
        return;
      }

      this.http.post(`/api/sso/result`, { nonce }).subscribe({
        next: (res: any) => {
          if (res?.body?.token) {
            localStorage.setItem('auth_token', res.body.token);
          }
          const encryptedData = res?.body?.data;
          if (!encryptedData) {
            this.loginErrMsg = 'Encrypted data missing';
            this.isLoginFailed = true;
            return;
          }

          const decryptedRes = this.commonService.decryptUsingAES256(encryptedData);
          // console.log(decryptedRes, "decryptedRes")
          if (decryptedRes?.isAuth === true) {
            this.loginService.setSession(decryptedRes);
            this.loginService.openLanguageModal();
          } else {
            // console.log("error log 1")
            //this.loginErrResp = 'SSO login failed.';
            this.loginErrMsg = "Currently, the portal access is restricted for the business user. However please reach out to below team for further review.";
            this.isLoginFailed = true;
          }
        },
        error: () => {
          // console.log("error log 2")

          this.loginErrMsg = "Currently, the portal access is restricted for the business user. However please reach out to below team for further review.";
          this.isLoginFailed = true;
          this.loginErrResp = 'SSO session expired, invalid, or nonce mismatch.';
        }
      });
    });
  }
  // handleUaepassCallback(code: string, state: string) {
  //   this.http.post(`/api/uaepass`, { code, state }).subscribe({
  //     next: (res: any) => {
  //       if (res?.token) {
  //         localStorage.setItem('auth_token', res.token);
  //       }
  //       const decryptedRes = this.commonService.decryptUsingAES256(res?.body?.data);
  //       if (decryptedRes?.isAuth === true) {
  //         this.setSession(decryptedRes);
  //         this.storageService.setSessionStorageData('isUAEPass', true);
  //         this.openLanguageModal();
  //       } else {
  //         this.loginErrMsg = "Currently, the portal access is restricted for the UAE PASS user. However please reach out to below team for further review.";
  //         this.isLoginFailed = true;
  //         //this.loginErrResp = 'UAE Pass login failed.';
  //       }
  //     },
  //     error: () => {
  //       this.loginErrMsg = "Currently, the portal access is restricted for the UAE PASS user. However please reach out to below team for further review.";
  //       this.isLoginFailed = true;
  //       this.loginErrResp = 'Error during UAE PASS login.';
  //     }
  //   });
  // }

  handleUaepassCallback(code: string, state: string) {
    // console.log('handleUaepassCallback invoked with:', { code, state });

    this.http.post(`/api/uaepass`, { code, state }).subscribe({
      next: (res: any) => {
        // console.log('Response from /api/uaepass:', res);
        if (!res?.body?.data) {
          console.warn('No encrypted data found in response body');
          this.loginErrMsg = "Login response missing required data.";
          this.isLoginFailed = true;
          return;
        }
        try {
          const decryptedRes = this.commonService.decryptUsingAES256(res?.body?.data);
          // console.log('Decrypted response data:', decryptedRes);

          if (decryptedRes?.isAuth === true) {
     //console.log('User is authenticated, setting session');
            if (decryptedRes.token) {
              // console.log('Storing token from decrypted response');
              localStorage.setItem('auth_token', decryptedRes.token);
            }
            this.loginService.setSession(decryptedRes);
            this.storageService.setSessionStorageData('isUAEPass', true);

            this.loginService.fetchUserAssAccounts()

          } else {
            if (res?.body?.error && res?.body?.error?.errMsg == "User not present") {
              // this.loginErrMsg = "Currently, the portal access is restricted for the UAE PASS user. However please reach out to below team for further review.";
              this.loginErrMsg = "This Service is only for registered users, please contact DIEZ support in order to access the services";
            } else {
              this.loginErrMsg = "This Service is only for registered users, please contact DIEZ support in order to access the services";
            }
            // console.warn('Authentication failed or isAuth flag not true:', decryptedRes);
            this.isLoginFailed = true;
            // Optionally, log the decrypted response for further insight
            // this.loginErrResp = 'UAE Pass login failed.';
          }
        } catch (error) {
          console.error('Error decrypting the response data:', error);
          this.loginErrMsg = "Failed to process the login response. Please try again later.";
          this.isLoginFailed = true;
        }
      },
      error: (err) => {
        console.error('Error during /api/uaepass HTTP call:', err);
        this.loginErrMsg = "The portal access is restricted for the UAE PASS user. However please reach out to below team for further review.";
        this.isLoginFailed = true;
        this.loginErrResp = 'Error during UAE PASS login.';
      }
    });
  }

  goToForgetPassword() {
    this.route.navigate(['forget-password']);
  }
}
